import React from 'react';
import './style.css';

// Shared split-screen layout for all auth screens (Sign In, Forgot/Reset Password,
// First-Time Password Change, OTP): banner image on the left, form content on the right.
const AuthLayout = ({ title, children }) => (
  <div className="auth-page">
    <div className="auth-page-main">
      <div className="auth-image-panel">
        <img alt="" src={require('./images/login-Image-new.png')} />
      </div>
      <div className="auth-content-panel">
        <div className="auth-content-inner">
          <div className="auth-logo">
            <img alt="VeraBenefits" className="auth-logo-img" src={require('./images/VERABenefitsLogo.png')} />
          </div>
          {title && <h2 className="auth-title">{title}</h2>}
          {children}
        </div>
      </div>
    </div>
    <div className="auth-footer">
      Copyright &copy; {new Date().getFullYear()} Vera Benefits, Inc. All rights reserved. &nbsp;|&nbsp; Powered by CarynHealth
      <br />
      Version 1.0.0
    </div>
  </div>
);

export default AuthLayout;
